import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-battery-0",
  "use": "icon-battery-0-usage",
  "viewBox": "0 0 175.001 92.063",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 175.001 92.063\" id=\"icon-battery-0\">\r\n  <g id=\"icon-battery-0_组_306\" data-name=\"组 306\" transform=\"translate(0 0)\">\r\n    <g id=\"icon-battery-0_dianchiyigetoumingdi\" transform=\"translate(0 0)\">\r\n      <path id=\"icon-battery-0_路径_320\" data-name=\"路径 320\" d=\"M35.617,164.283c-4.562,0-8.709-5.806-8.709-13.27v-40.64c0-7.465,4.147-13.685,8.709-13.685H162.928c4.976,0,9.123,6.22,9.123,13.685v40.64c0,7.465-4.147,13.27-8.709,13.27Zm147.217-13.27v-4.562h2.488c3.318,0,5.806-2.9,5.806-6.635V121.155c0-3.732-2.488-6.635-5.806-6.635h-2.488v-4.147c0-14.1-8.709-25.711-19.491-25.711H35.617c-10.782,0-19.491,11.611-19.491,25.711v40.64c0,14.1,8.709,25.711,19.491,25.711H162.928C173.71,176.724,182.834,165.112,182.834,151.013Zm0,0\" transform=\"translate(-16.126 -84.661)\" fill=\"#999\" />\r\n    </g>\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/battery-0.svg
// module id = fMFg
// module chunks = 167